<div *ngIf="displeyIdl">
    <div class="swal2-container swal2-center swal2-backdrop-show">
        <div
            class="swal2-popup swal2-modal swal2-show centrar"
            tabindex="-1"
            role="dialog"
            aria-live="assertive"
            aria-modal="true"
            style="display: flex">
            <div class="swal2-header view_conteiner-alert">
                <button class="view_btn-close" (click)="continuar()">
                    <i class="fas fa-times"></i>
                </button>
                <h2
                    class="swal2-title"
                    id="swal2-title"
                    style="
                        display: flex;
                        font-size: 1.5rem;
                        margin-bottom: 1rem;
                    ">
                    {{ mensaje }}
                </h2>
                <button
                    type="button"
                    class="view_btn-alert"
                    (click)="continuar()">
                    {{ nombreBtn }}
                </button>
            </div>
        </div>
    </div>
</div>
